// Date du jour au format YYYY-MM-DD en heure LOCALE du navigateur — ne pas utiliser
// toISOString() ici, qui convertit en UTC et fait basculer la date au jour suivant
// des la fin de journee locale pour un fuseau derriere UTC (ex: Haiti, UTC-4/-5).
const toISO = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const todayISO = () => toISO(new Date());

export const daysAgoISO = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return toISO(d);
};
